export enum GigStatuses {
  DRAFT = 1,
  PUBLISHED = 2,
}
